import { IScriptCompliance } from "@shared/lib/types/scripting";
import { useQuery } from "@tanstack/react-query";
import { generateScriptingComplianceKey } from "../../constants";
import { BriefService } from "../../services/brief.service";

export default function useGetScriptingCompliance(data: IScriptCompliance) {
  const {
    data: scriptingComplianceInfo,
    isFetching: isScriptingComplianceFetching,
    error: scriptingComplianceError,
    isSuccess: isScriptingComplianceSuccess,
    isFetched: isScriptingComplianceFetched,
    refetch: scriptingComplianceRefetch,
  } = useQuery({
    queryFn: () => BriefService.getScriptingCompliance(data),
    queryKey: [...generateScriptingComplianceKey(data.scriptId)],
    refetchInterval: (query) => {
      const complianceStatus = query?.state?.data?.data?.complianceCheckStatus;
      const feedbackStatus = query?.state?.data?.data?.feedbackSummaryStatus;

      const shouldPollCompliance = complianceStatus === "Pending";

      const shouldPollFeedback = feedbackStatus === "Pending";

      return shouldPollCompliance || shouldPollFeedback ? 5000 : undefined;
    },
    refetchIntervalInBackground: true,
    enabled: !!data.scriptId,
    placeholderData: (prev) => prev,
  });

  return {
    scriptingComplianceInfo,
    isScriptingComplianceFetching,
    scriptingComplianceError,
    isScriptingComplianceSuccess,
    isScriptingComplianceFetched,
    scriptingComplianceRefetch,
  };
}
